import { render, staticRenderFns } from "./H7ComparisonTable.vue?vue&type=template&id=1537faaa&scoped=true"
import script from "./H7ComparisonTable.vue?vue&type=script&lang=js"
export * from "./H7ComparisonTable.vue?vue&type=script&lang=js"
import style0 from "./H7ComparisonTable.vue?vue&type=style&index=0&id=1537faaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1537faaa",
  null
  
)

export default component.exports